module.exports = __webpack_public_path__ + "img/logo-dreamocean.592071b8.png";